import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IQuizPoints, IQuizSlice, IUserQuestions, QuizStep, QuizType, UserStatus } from "../../interfaces/interfaces"
import { UserQuizStatus } from "../../interfaces/enums";

const quizStates: IQuizSlice = {
    quiz: undefined,
    userStatus: UserQuizStatus.viewer,
    step: 0,
    correctAnswerId: undefined,
    participants: [],
    counter: undefined,
    points: {
        userCorrectAnswers:0,
        userFirstAnswer: 0,
        userLastAnswer: 0,
        userAnswers: 0
    },
    correctAnswersCount: 0,
    participationAnswersCount: 0,
    userAnswerId: 0,
    userQuestionId: 0,
    userQuestions: [],
    chances: -1,
    maxChances: -1,
}

export const quizSlice = createSlice({
    name: 'quiz',
    initialState: quizStates,
    reducers: {
        setQuiz: (state, action: PayloadAction<QuizType[] | undefined>) => {
            state.quiz = action.payload
        },
        setUserStatus: (state, action: PayloadAction<UserStatus>) => {
            state.userStatus = action.payload;
        },
        setQuizStep: (state, action: PayloadAction<QuizStep>) => {
            state.step = action.payload;
        },
        setCorrectAnswerId: (state, action: PayloadAction<number>) => {
            state.correctAnswerId = action.payload;
        },
        setParticipants: (state, action: PayloadAction<number[]>) => {
            state.participants = action.payload;
        },
        setCounter: (state, action: PayloadAction<number | undefined>) => {
            state.counter = action.payload;
        },
        setPoints: (state, action: PayloadAction<IQuizPoints>) => {
            state.points = action.payload;
        },
        setCorrectAnswersCount: (state, action: PayloadAction<number>) => {
            state.correctAnswersCount = action.payload;
        },
        setUserAnswersCount: (state, action: PayloadAction<number>) => {
            state.participationAnswersCount = action.payload;
        },
        setUserAnswerId: (state, action: PayloadAction<number>) => {
            state.userAnswerId = action.payload;
        },
        setUserQuestionId: (state, action: PayloadAction<number>) => {
            state.userQuestionId = action.payload;
        },
        setUserQuestions: (state, action: PayloadAction<IUserQuestions[]>) => {
            state.userQuestions = action.payload;
        },
        setChances: (state, action: PayloadAction<number>) => {
            state.chances = action.payload;
        },
        setMaxChances: (state, action: PayloadAction<number>) => {
            state.maxChances = action.payload;
        },
        setClearQuizInfo: () => {
            return quizStates;
        },
    }
})

export const {
    setQuiz,
    setUserStatus,
    setQuizStep,
    setUserAnswerId,
    setCorrectAnswerId,
    setParticipants,
    setCounter,
    setPoints,
    setCorrectAnswersCount,
    setUserAnswersCount,
    setUserQuestionId,
    setUserQuestions,
    setChances,
    setMaxChances,
    setClearQuizInfo
} = quizSlice.actions;

export default quizSlice.reducer;